module.exports = __webpack_public_path__ + "img/lgt.e0b9c44d.svg";